import type { GoogleReviews } from "@/hooks/use-google-reviews"

/**
 * Manually-maintained Google rating + review count, used while there is no
 * Google Places API key configured. The live Convex value (when available)
 * always overrides this.
 *
 * IMPORTANT: keep these numbers truthful — they must match what is actually
 * shown on the business's Google listing. Update them by hand every few months.
 *
 * Set to `null` to hide the rating entirely. To enable, replace with e.g.:
 *   { rating: 4.9, userRatingCount: 213, fetchedAt: Date.now() }
 */
export const MANUAL_GOOGLE_REVIEWS: GoogleReviews | null = {
  rating: 4.7,
  userRatingCount: 101,
  fetchedAt: Date.now(),
}
